import { render } from "./wfm-detail.vue?vue&type=template&id=1c105ea3"
import script from "./wfm-detail.vue?vue&type=script&lang=js"
export * from "./wfm-detail.vue?vue&type=script&lang=js"

import "./wfm-detail.vue?vue&type=style&index=0&id=1c105ea3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__